import React from 'react'

const ErrorList = props => {
    const errors = props.errors

    return (
        <ul>
            {    
                errors.map((key, index) => {
                    return <li key={index}>{key}</li>
                })
            }
        </ul>
    )
}

export default ErrorList;